module.exports = __webpack_public_path__ + "img/thumbnail_Emu_f_normal.02b9a243.png";